// extracted by mini-css-extract-plugin
export default {"p":"styles_p__xf3kc","h":"styles_h__4qjAI"};